import { CONTRACT_ADDRESSES } from './contracts';

// Mainnet-only configuration
export const MAINNET_CONFIG = {
  environment: 'mainnet',
  apiUrl: process.env.REACT_APP_API_URL || 'https://api.zkbridge.com',
  proverUrl: process.env.REACT_APP_PROVER_URL || 'https://prover.zkbridge.com',
  
  // Network configurations - now using environment variables
  networks: {
    bscMainnet: {
      name: 'BSC Mainnet',
      id: parseInt(process.env.REACT_APP_BSC_MAINNET_CHAIN_ID || '56'),
      rpcUrl: process.env.REACT_APP_BSC_MAINNET_RPC_URL || 'https://api-bsc-mainnet-full.n.dwellir.com/c6fd7c04-24d6-4cb1-881b-c3c3a43ba755',
      explorer: process.env.REACT_APP_BSC_MAINNET_EXPLORER || 'https://bscscan.com',
      currency: process.env.REACT_APP_BSC_MAINNET_CURRENCY || 'BNB',
      color: 'bg-yellow-500',
      contracts: CONTRACT_ADDRESSES[56]
    },
    xphereMainnet: {
      name: 'Xphere Mainnet', 
      id: parseInt(process.env.REACT_APP_XPHERE_MAINNET_CHAIN_ID || '20250217'),
      rpcUrl: process.env.REACT_APP_XPHERE_MAINNET_RPC_URL || 'https://xp-mainnet.rpc.xplorium.xyz',
      explorer: process.env.REACT_APP_XPHERE_MAINNET_EXPLORER || 'https://xp.tamsa.io',
      currency: process.env.REACT_APP_XPHERE_MAINNET_CURRENCY || 'XPH',
      color: 'bg-red-500',
      contracts: CONTRACT_ADDRESSES[20250217]
    }
  },
  
  // Bridge pairs
  bridgePairs: [
    {
      source: 'bscMainnet',
      destination: 'xphereMainnet',
      sourceToken: 'USDT',
      destToken: 'USDX',
      description: 'USDT (BSC Mainnet) → USDX (Xphere Mainnet)'
    },
    {
      source: 'xphereMainnet',
      destination: 'bscMainnet',
      sourceToken: 'USDX',
      destToken: 'USDT',
      description: 'USDX (Xphere Mainnet) → USDT (BSC Mainnet)'
    }
  ]
};

export const getApiUrl = () => MAINNET_CONFIG.apiUrl;
export const getProverUrl = () => MAINNET_CONFIG.proverUrl;
export const getNetworkConfig = () => MAINNET_CONFIG.networks;
export const getBridgePairs = () => MAINNET_CONFIG.bridgePairs;
